{
  "WALLBOARD": {
    "LOADING": "Učitavanje redova čekanja telefona...",
    "NO_QUEUES": "Nije pronađen nijedan red čekanja telefona.",
    "AGENTS": "Agenti",
    "NO_AGENTS": "Nema aktivnih agenata u ovom redu čekanja.",
    "NO_AGENTS_ONLINE": "Nema aktivnih agenata.",
    "WAITING_CALLERS": "Pozivatelji na čekanju",
    "NO_CALLERS": "Nema pozivatelja na čekanju.",
    "UNKNOWN_CALLER": "Nepoznati pozivatelj",
    "POSITION": "Pozicija",
    "STATUS": "Status",
    "TIME": "Vrijeme",
    "AGENT": "Agent",
    "EXTENSION": "Lokal",
    "AVAILABLE": "Dostupno",
    "READY": "Spremni agenti",
    "ON_CALL": "Agenti na pozivu",
    "QUEUE_CALL": "Poziv iz reda čekanja",
    "OTHER_CALL": "Drugi poziv",
    "PAUSED": "Agenti na pauzi",
    "WAITING": "Pozivi na čekanju",
    "MISSED_CALLS": "Propušteni pozivi",
    "HANDLED_CALLS": "Obrađeni dolazni pozivi",
    "OUTBOUND_CALLS": "Obrađeni odlazni pozivi",
    "AVAILABILITY": "Dostupnost",
    "AVAILABILITY_TOOLTIP": "Postotak dolaznih poziva na koje su agenti odgovorili (pozivi koji su preuzeti)",
    "TOTAL": "ukupno",
    "AGENTS_COUNT": "({onCall} na pozivu / {total} ukupno)",
    "NO_AVAILABLE": "(nitko nije aktivan)",
    "WAITING_CALLERS_COUNT": "{count} na čekanju",
    "CALLER": "Pozivatelj",
    "NUMBER": "Broj",
    "WAIT_TIME": "Vrijeme čekanja",
    "QUEUES": "Redovi čekanja",
    "ACTION": "Radnja",
    "PICKUP_CALL": "Preuzmi",
    "PICKING_UP": "Preuzimanje...",
    "PICKUP_SUCCESS": "Zahtjev za preuzimanjem poziva uspješno poslan.",
    "PICKUP_ERROR": "Preuzimanje poziva nije uspjelo. Pokušajte ponovno.",
    "PICKUP_DISABLED_TOOLTIP": "Ne možete preuzeti poziv dok ste na pozivu ili nedostupni.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Nema pristupa"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Nema pristupa"
    }
  }
}
